import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import { DEFAULT_TIME_SEGMENT_DELIMITER } from '../timePicker/timePicker.utils';
dayjs.extend(customParseFormat);
dayjs.extend(utc);
var DEFAULT_DATE_SEGMENT_DELIMITER = '-';
export var DEFAULT_DATE_TIME_STRING_SEGMENT_DELIMITER = ' ';
export function getDefaultDateTimeFormat(_a) {
    var use12HourClock = _a.use12HourClock, withSeconds = _a.withSeconds;
    return [
        ['YYYY', 'MM', 'DD'].join(DEFAULT_DATE_SEGMENT_DELIMITER),
        [use12HourClock ? 'hh' : 'HH', 'mm', withSeconds && 'ss'].filter(function (str) { return str; }).join(DEFAULT_TIME_SEGMENT_DELIMITER),
        use12HourClock && 'A',
    ]
        .filter(function (str) { return str; })
        .join(DEFAULT_DATE_TIME_STRING_SEGMENT_DELIMITER);
}
export function defaultParseDateTime(value, params) {
    var day = dayjs(value, getDefaultDateTimeFormat(params), true);
    return day.isValid() ? day.toISOString() : undefined;
}
